module.exports = __webpack_public_path__ + "assets/img/head_big_cat.9fc5d981.jpg";